<div *ngIf="data" [innerHtml]="data | safeHtml"></div>
<app-loader *ngIf="!data" class="no-overlay"></app-loader>